let onScroll = null

export function startNav() {
  stopNav()
  const nav = document.querySelector("[data-nav]")
  if (!nav) return

  onScroll = () => {
    nav.classList.toggle("is-scrolled", window.scrollY > 24)
  }
  onScroll()
  window.addEventListener("scroll", onScroll, { passive: true })
}

export function stopNav() {
  if (onScroll) window.removeEventListener("scroll", onScroll)
  onScroll = null
}
